(function () {
    const DATA_SELECTOR = '[id^="mp-collection-hero-data-"]';
    const HERO_SELECTOR = '[data-mp-collection-hero-wrap]';
    const TITLE_WRAPPER_SELECTOR = '.mp-custom-title';
    const RESULTS_SELECTOR = '.wizzy-search-results-container';
    const MAIN_WRAPPER_SELECTOR = '#wizzy-shopify-collection-page-wrapper';
    const FILTERS_SELECTOR = '.wizzy-search-filters-left.wizzy-v1';

    const MOBILE_MAX = 480;
    const TABLET_MAX = 1440;

    let observer = null;
    let isInjectingHero = false;
    let reinjectTimeout = null;
    let lastViewportMode = null;

    function getDataNode() {
        return document.querySelector(DATA_SELECTOR);
    }

    function getData() {
        const node = getDataNode();

        if (!node) {
            console.warn('[MP Hero] JSON data node not found');
            return null;
        }

        try {
            return JSON.parse(node.textContent);
        } catch (error) {
            console.warn('[MP Hero] JSON parse error', error);
            return null;
        }
    }

    function getResultsContainer() {
        return document.querySelector(RESULTS_SELECTOR);
    }

    function getMainWrapper() {
        return document.querySelector(MAIN_WRAPPER_SELECTOR);
    }

    function getFiltersBlock() {
        return document.querySelector(FILTERS_SELECTOR);
    }

    function isFirstPage() {
        const url = new URL(window.location.href);
        const page = url.searchParams.get('page');
        return !page || page === '1';
    }

    function getViewportMode() {
        const width = window.innerWidth;
        if (width <= MOBILE_MAX) return 'mobile';
        if (width <= TABLET_MAX) return 'tablet';
        return 'desktop';
    }

    function isMobileOrTabletLayout() {
        return getViewportMode() !== 'desktop';
    }

    function removeAllHeroes() {
        document.querySelectorAll(HERO_SELECTOR).forEach((el) => el.remove());
    }

    function removeAllTitles() {
        document.querySelectorAll(TITLE_WRAPPER_SELECTOR).forEach((el) => el.remove());
    }

    function escapeHtml(value) {
        return String(value || '')
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
    }

    function getBannerImageForViewport(banner) {
        if (!banner) return null;

        const mode = getViewportMode();

        if (mode === 'mobile') {
            return banner.image_mobile || banner.image_tablet || banner.image || null;
        }

        if (mode === 'tablet') {
            return banner.image_tablet || banner.image || banner.image_mobile || null;
        }

        return banner.image || banner.image_tablet || banner.image_mobile || null;
    }

    function buildCardsLinksHtml(links) {
        if (!links.length) return '';

        const mobile = isMobileOrTabletLayout();

        const className = mobile
            ? 'mp-collection-links mp-collection-links--cards-mobile'
            : 'mp-collection-links mp-collection-links--cards';

        return `
    <div class="${className}">
      ${links
            .map(
                (item) => `
          <a class="mp-collection-links__item" href="${escapeHtml(item.url || '#')}">
            <span class="mp-collection-links__image">
              ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title || '')}">` : ''}
            </span>
            <span class="mp-collection-links__title">${escapeHtml(item.title || '')}</span>
          </a>
        `
            )
            .join('')}
    </div>
  `;
    }

    function buildPillsLinksHtml(links) {
        if (!links.length) return '';

        return `
    <div class="mp-collection-pills">
      ${links
            .map(
                (item) => `
          <a class="mp-collection-pill" href="${escapeHtml(item.url || '#')}">
            <span class="mp-collection-pill__text">${escapeHtml(item.title || '')}</span>
          </a>
        `
            )
            .join('')}
    </div>
  `;
    }

    function buildHero(data) {
        const banner = data.banner || {};
        const links = Array.isArray(data.links) ? data.links : [];
        const bannerImage = getBannerImageForViewport(banner);

        const linksView = data.linksView || 'cards';
        const mobile = isMobileOrTabletLayout();
        const pillsMobileLayout = linksView === 'pills' && mobile;

        const bannerHTML = bannerImage
            ? `
      <div class="mp-collection-hero">
        ${
                banner.buttonLink
                    ? `
          <a class="mp-collection-hero__link" href="${escapeHtml(banner.buttonLink)}">
            <img class="mp-collection-hero__image"
                 src="${escapeHtml(bannerImage)}"
                 alt="${escapeHtml(data.collectionTitle || '')}">
          </a>
          `
                    : `
          <div class="mp-collection-hero__link">
            <img class="mp-collection-hero__image"
                 src="${escapeHtml(bannerImage)}"
                 alt="${escapeHtml(data.collectionTitle || '')}">
          </div>
          `
            }
      </div>
    `
            : '';

        let linksHTML = '';

        if (links.length) {
            linksHTML =
                linksView === 'pills'
                    ? buildPillsLinksHtml(links)
                    : buildCardsLinksHtml(links);
        }

        if (!bannerHTML && !linksHTML) return '';

        return `
    <div class="mp-collection-hero-wrap ${
            pillsMobileLayout ? 'mp-collection-hero-wrap--pills-mobile' : ''
        }" data-mp-collection-hero-wrap>
      ${pillsMobileLayout ? linksHTML : bannerHTML}
      ${pillsMobileLayout ? bannerHTML : linksHTML}
    </div>
  `;
    }


    function buildTitleHtml(title) {
        const wrapper = document.createElement('div');
        wrapper.className = 'mp-custom-title';

        const h1 = document.createElement('h1');
        h1.className =
            'mp-collection-title tw-text-black tw-text-[28px] tw-leading-[38px] md:tw-text-[32px] md:tw-leading-[40px] lg:tw-text-[40px] lg:tw-leading-[48px]';

        h1.textContent = title;
        wrapper.appendChild(h1);

        return wrapper;
    }

    function insertCollectionTitle() {
        const data = getData();
        const title = data?.collectionTitle;

        if (!title) return;

        removeAllTitles();

        if (isMobileOrTabletLayout()) {
            const hero = document.querySelector(HERO_SELECTOR);
            const mainWrapper = getMainWrapper();

            if (hero) {
                hero.before(buildTitleHtml(title));
                return;
            }

            if (mainWrapper) {
                mainWrapper.before(buildTitleHtml(title));
            }

            return;
        }

        const filtersBlock = getFiltersBlock();
        if (filtersBlock) {
            filtersBlock.prepend(buildTitleHtml(title));
            return;
        }

        const resultsContainer = getResultsContainer();
        if (resultsContainer) {
            resultsContainer.before(buildTitleHtml(title));
        }
    }

    function heroIsCorrectlyPlaced() {
        const hero = document.querySelector(HERO_SELECTOR);
        if (!hero) return false;

        if (isMobileOrTabletLayout()) {
            const mainWrapper = getMainWrapper();
            return !!mainWrapper && hero.nextElementSibling === mainWrapper;
        }

        const resultsContainer = getResultsContainer();
        return !!resultsContainer && resultsContainer.firstElementChild === hero;
    }

    function safeReinject(reason = 'scheduled', delay = 120) {
        clearTimeout(reinjectTimeout);
        reinjectTimeout = setTimeout(() => {
            insertAll(reason);
        }, delay);
    }

    function initScrollerDrag() {
        const scroller = document.querySelector('.mp-collection-links');
        if (!scroller) return;
        if (scroller.dataset.dragReady === 'true') return;

        scroller.dataset.dragReady = 'true';

        let isDragging = false;
        let hasDragged = false;
        let startX = 0;
        let startScrollLeft = 0;
        const dragThreshold = 3;

        const onMouseDown = (e) => {
            if (e.button !== 0) return;
            isDragging = true;
            hasDragged = false;
            startX = e.clientX;
            startScrollLeft = scroller.scrollLeft;
            scroller.classList.add('is-dragging');
            e.preventDefault();
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        };

        const onMouseMove = (e) => {
            if (!isDragging) return;

            const dx = e.clientX - startX;

            if (Math.abs(dx) > dragThreshold) hasDragged = true;
            scroller.scrollLeft = startScrollLeft - dx;

            if (hasDragged) {
                e.preventDefault();
            }
        };

        const onMouseUp = () => {
            if (!isDragging) return;

            isDragging = false;
            scroller.classList.remove('is-dragging');
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);

            setTimeout(() => {
                hasDragged = false;
            }, 150);
        };

        scroller.addEventListener('mousedown', onMouseDown);

        scroller.addEventListener(
            'click',
            (e) => {
                if (hasDragged) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            true
        );
    }

    function insertHero(reason = 'manual') {
        const data = getData();

        if (!data) {
            console.warn('[MP Hero] Insert aborted: no data');
            return;
        }

        if (data.showOnFirstPageOnly && !isFirstPage()) {
            removeAllHeroes();
            removeAllTitles();
            return;
        }

        const resultsContainer = getResultsContainer();
        const mainWrapper = getMainWrapper();

        if (!resultsContainer || !mainWrapper) {
            console.warn('[MP Hero] Insert aborted: containers not found', { reason });
            return;
        }

        const heroMarkup = buildHero(data).trim();

        if (!heroMarkup) {
            removeAllHeroes();
            return;
        }

        if (heroIsCorrectlyPlaced()) {
            const currentHero = document.querySelector(HERO_SELECTOR);
            const currentImage = currentHero?.querySelector('.mp-collection-hero__image');
            const nextImage = getBannerImageForViewport(data.banner || {});

            if (currentImage && nextImage && currentImage.getAttribute('src') !== nextImage) {
                removeAllHeroes();
            } else {
                initScrollerDrag();
                return;
            }
        }

        isInjectingHero = true;
        removeAllHeroes();

        if (isMobileOrTabletLayout()) {
            mainWrapper.insertAdjacentHTML('beforebegin', heroMarkup);
        } else {
            resultsContainer.insertAdjacentHTML('afterbegin', heroMarkup);
        }

        requestAnimationFrame(() => {
            isInjectingHero = false;
            initScrollerDrag();
        });
    }

    function insertAll(reason = 'manual') {
        insertHero(reason);
        insertCollectionTitle();
    }

    function startObserver() {
        const mainWrapper = getMainWrapper();
        const resultsContainer = getResultsContainer();

        if (!mainWrapper && !resultsContainer) return;

        if (observer) observer.disconnect();

        observer = new MutationObserver((mutations) => {
            if (isInjectingHero) return;

            let shouldReinject = false;

            for (const mutation of mutations) {
                if (mutation.type !== 'childList') continue;

                const nodes = [
                    ...Array.from(mutation.addedNodes || []),
                    ...Array.from(mutation.removedNodes || [])
                ];

                const hasRelevantNode = nodes.some((node) => {
                    if (!(node instanceof HTMLElement)) return false;
                    if (node.matches(HERO_SELECTOR)) return false;
                    if (node.matches(TITLE_WRAPPER_SELECTOR)) return false;
                    if (node.querySelector?.(HERO_SELECTOR)) return false;
                    if (node.querySelector?.(TITLE_WRAPPER_SELECTOR)) return false;
                    return true;
                });

                if (hasRelevantNode) {
                    shouldReinject = true;
                    break;
                }
            }

            if (!shouldReinject) return;
            safeReinject('mutation');
        });

        if (mainWrapper) {
            observer.observe(mainWrapper, {
                childList: true,
                subtree: true
            });
        }

        if (resultsContainer) {
            observer.observe(resultsContainer, {
                childList: true,
                subtree: true
            });
        }
    }

    function waitForWizzy(maxAttempts = 50, interval = 250) {
        let attempts = 0;

        const timer = setInterval(() => {
            attempts += 1;

            const resultsContainer = getResultsContainer();
            const mainWrapper = getMainWrapper();

            if (resultsContainer && mainWrapper) {
                clearInterval(timer);
                insertAll('wizzy-ready');
                startObserver();
                lastViewportMode = getViewportMode();
            }

            if (attempts >= maxAttempts) {
                clearInterval(timer);
            }
        }, interval);
    }

    function attachHooks() {
        window.addEventListener('load', () => {
            safeReinject('window-load', 50);
        });

        document.addEventListener('DOMContentLoaded', () => {
            safeReinject('dom-ready', 50);
        });

        window.addEventListener('popstate', () => {
            safeReinject('popstate', 150);
        });

        document.addEventListener('click', (event) => {
            const trigger = event.target.closest(
                '.wizzy-filters, .wizzy-filter-list-block, .wizzy-search-sort-container, .wizzy-search-results-container, #wizzy-shopify-collection-page-wrapper'
            );

            if (!trigger) return;

            safeReinject('click', 180);
            setTimeout(() => safeReinject('click-delayed', 80), 350);
        });

        window.addEventListener('resize', () => {
            const currentViewportMode = getViewportMode();
            if (currentViewportMode === lastViewportMode) return;

            lastViewportMode = currentViewportMode;
            safeReinject('viewport-change', 80);
        });
    }

    function init() {
        waitForWizzy();
        attachHooks();
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    }

    window.MPCollectionHeroDebug = {
        getData,
        insert() {
            insertAll('manual-debug');
        },
        remove() {
            removeAllHeroes();
            removeAllTitles();
        }
    };
})();
